import BrandTopicPage from './BrandTopicPage';

export default BrandTopicPage;
